import APIError from '../APIError';
class BadRequest extends APIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        const status = 400;
        super(status, ...args);
    }
}
export default BadRequest;
